import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from '@nuxtjs/composition-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutUsMap',
  setup(__props) {

const BravadoMap = () => import('@/components/partials/landings/ui/BravadoMap.vue');

const showMap = ref(false);
const root = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | undefined;

onMounted(() => {
  if (root.value) {
    observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        showMap.value = true;
        observer?.disconnect();
      }
    });

    console.log('observing');
    observer.observe(root.value);
  }
});

onUnmounted(() => {
  console.log('unobserving');
  observer?.disconnect();
});

return { __sfc: true,BravadoMap, showMap, root, observer }
}

})